<template>
      <div class="appointmentTypeEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'appointmentType', params: {} }">
          Appointment Type
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'appointmentTypeEdit', params:{id: id} }">
            Edit Appointment Type
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Appointment Type</v-card-title>
          <v-card-text>
            <appointmentType-form :id="id"></appointmentType-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import AppointmentTypeForm from './AppointmentTypeForm.vue';

    export default {
      name: 'appointmentType',
      data () {
        return {
          id: null
        }
      },
      components: {
        AppointmentTypeForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    